import { gql } from '@apollo/client';

const setSystemProviderActive = gql`
  mutation SetSystemProviderActive($id: Int!, $active: Boolean!) {
    setSystemProviderActive(id: $id, active: $active) {
      id
      name
      recipient_email
      is_active
      letter_template_id
      letter_template_name
      openScheduledCount
      createdAt
      updatedAt
    }
  }
`;

export default setSystemProviderActive;
